
    customElements.whenDefined('sp-dropzone').then(() => {
        const dropzone = document.getElementById('dropzone');
        const message = document.getElementById('message');
        const fileInput = document.getElementById('file-input');
        let input;
        let beingDraggedOver = false;

        const updateMessage = () => {
            message.heading = input !== undefined
                ? (beingDraggedOver ? 'Drop here to replace!' : 'You dropped something!')
                : 'Drag and drop your file';
        };

        const handleDropOrChange = () => {
            input = 'mock-file';
            dropzone.setAttribute("filled", true);
            beingDraggedOver = false;
            updateMessage();
        };

        dropzone.addEventListener('dragover', (event) => {
            event.preventDefault();
            beingDraggedOver = true;
            updateMessage();
        });

        dropzone.addEventListener('dragleave', () => {
            beingDraggedOver = false;
            updateMessage();
        });

        dropzone.addEventListener('drop', (event) => {
            event.preventDefault();
            handleDropOrChange();
        });

        fileInput.addEventListener('change', handleDropOrChange);
    });
